/**
 * The web maintenance packages for the Saidiseire screens: the add and edit
 * dialog's list, and the package names on the site page
 * (docs/saidiseire-paketid.md).
 *
 * Read once per mount. Packages change in the package editor, not while
 * somebody looks at a site, so no polling. A failed read leaves `null`, and
 * the screens fall back to the bare package codes rather than showing nothing.
 */
import { useEffect, useState } from "react";
import { listMonitorPlans, type MonitorPlansResponse } from "../../../lib/monitoring";

export function useMonitorPlans(): MonitorPlansResponse | null {
  const [data, setData] = useState<MonitorPlansResponse | null>(null);
  useEffect(() => {
    const ctrl = new AbortController();
    listMonitorPlans(ctrl.signal)
      .then((res) => {
        if (!ctrl.signal.aborted) setData(res);
      })
      .catch(() => {
        // Left null: every screen that reads it has a fallback.
      });
    return () => ctrl.abort();
  }, []);
  return data;
}
